import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom-latest';
import PageHeaderTabs, { pageHeaderTabId } from 'common/PageHeaderTabs';
import { withStorageData } from 'utilities/withStorageData';
import Security from 'ui/Admin/Security';
import Settings from 'ui/Admin/Settings';
import AddEditTags from './AddEditTags';
import TextLogs from './TextLogs';

const PANEL_ID = 'preferences-tabpanel';

const Preferences = () => {
  const navigate = useNavigate();
  // Build main tabs array
  const PreferencesTabs = useMemo(() => [
    {
      label: 'Settings',
      value: 'settings',
      tab: <Settings />
    },
    {
      label: 'Security',
      value: 'security',
      tab: <Security />
    },
    {
      label: 'Tags',
      value: 'tags',
      tab: <AddEditTags/>
    },
    {
      label: 'Text Logs',
      value: 'textLogs',
      tab: <TextLogs/>
    },
  ], []);

  // Initialize state with active tab - default to Settings tab
  const parsedUrl = new URL(window.location.href);
  const tab = parsedUrl.searchParams.get('tab');
  let tabIndex = 0;
  if (tab) {
    tabIndex = PreferencesTabs.findIndex((each) => each.value === tab);
  }
  const [activeTab, setActiveTab] = useState(tabIndex === -1 ? 0 : tabIndex);

  useEffect(() => {
    document.title = 'Preferences';
    if (activeTab !== undefined && PreferencesTabs[activeTab]) {
      navigate(
        `/preferences?tab=${PreferencesTabs[activeTab].value}`,
      );
    }
  }, [activeTab, navigate, PreferencesTabs]);

  const changeActiveTab = (key) => {
    setActiveTab(key);
    navigate(`/preferences?tab=${PreferencesTabs[key].value}`);
  };

  return (
    <div id="content">
      <PageHeaderTabs
        data={PreferencesTabs}
        activeTab={activeTab}
        handleClick={changeActiveTab}
        aria-label="Preferences tab"
        panelId={PANEL_ID}
        tabHref={({ value }) => `/preferences?tab=${value}`}
      />
      <div
        role="tabpanel"
        id={PANEL_ID}
        aria-labelledby={pageHeaderTabId(PANEL_ID, activeTab)}
      >
        {PreferencesTabs[activeTab].tab}
      </div>
    </div>
  );
};

export default withStorageData(Preferences);
